import { ApolloClient } from "@apollo/client";
import { AccountingJournalEntry, AccountingJournalEntryProps } from "@/core/entities/accounting/AccountingJournalEntry";
import {
  IAccountingJournalEntryRepository,
  IGetAccountingJournalEntriesRepositoryParams,
  IGetAccountingJournalEntriesRepositoryResponse,
} from "@/core/repositories/accounting/IAccountingJournalEntry.repository";
import { IDeductionColumns } from "@/core/repositories/deduction/IDeduction.repository";
import GET_ACCOUNTING_REMITTANCES_FOR_JOURNAL_ENTRY from "@/core/graphql/accounting/getAccountingRemittancesForJournalEntry";

interface IGetAccountingJournalEntriesQueryResponse {
  getAccountingRemittancesForJournalEntry: {
    total: number;
    page: number;
    limit: number;
    columns: IDeductionColumns[];
    innerColumns: IDeductionColumns[];
    items: AccountingJournalEntryProps[];
  };
}

export class AccountingJournalEntryRepository implements IAccountingJournalEntryRepository {
  constructor(private readonly client: ApolloClient) {}

  public async getAccountingJournalEntries(
    params: IGetAccountingJournalEntriesRepositoryParams,
    refetch: boolean = false
  ): Promise<IGetAccountingJournalEntriesRepositoryResponse> {
    const { data } = await this.client.query<IGetAccountingJournalEntriesQueryResponse>({
      query: GET_ACCOUNTING_REMITTANCES_FOR_JOURNAL_ENTRY,
      variables: { params },
      fetchPolicy: refetch ? "network-only" : "cache-first",
    });

    if (!data) {
      throw new Error("Failed to get accounting journal entries");
    }

    return {
      journalEntries: data.getAccountingRemittancesForJournalEntry.items.map(item =>
        AccountingJournalEntry.fromJson(item)
      ),
      totalCount: data.getAccountingRemittancesForJournalEntry.total,
      currentPage: data.getAccountingRemittancesForJournalEntry.page,
      pageLimit: data.getAccountingRemittancesForJournalEntry.limit,
      columns: data.getAccountingRemittancesForJournalEntry.columns,
      innerColumns: data.getAccountingRemittancesForJournalEntry.innerColumns,
    };
  }
}
